import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { makeStyles } from '@material-ui/core/styles';


export default function BasicPagination(props) {

  // customize style for pagination list color
  const useStyles = makeStyles(() => ({
    selected: {
      "& .Mui-selected": {
        backgroundColor: `${props.color ? props.color : '#0B5FFF'}`,
        color: `${props.color ? 'black' : 'white'}`,
      }
    }
  }));

  const classes = useStyles();
  const pageNumber = Math.ceil(props.totalPosts / props.postsPerPage);
    

  return (
    <Stack spacing={2}>
      <Pagination size="small" sx={{margin: '8px 8px 8px -10px'}} count={pageNumber} classes={{ul: classes.selected}} page={props.currentPage} defaultPage={1} siblingCount={0} boundaryCount={1}  onChange={(e, value) => props.paginate(value)}/>
    </Stack>
  );
}